import CustomModal from '../../modals';
import { deleteDealReminderThunk } from '../../../redux/thunks/reminder';
import { red } from '../../../theme/themePrimitives';
import { TransformedCalendarEventObject } from '../../../params/redux/calendar';
import { useParams } from 'react-router';
import { useState } from 'react';
import { AppDispatch, RootState } from '../../../redux/store';
import { Box, Button, Typography } from '@mui/material';
import { fetchCalendarReminderThunk, fetchGoogleEventsThunk } from '../../../redux/thunks/calendar';
import { formatDate, formatTime } from '../../../helper';
import { useDispatch, useSelector } from 'react-redux';

interface CalendarReminderDetailProps {
    open: boolean;
    onClose: () => void;
    selectedEvent: TransformedCalendarEventObject;
}

const CalendarReminderDetail = ({ open, onClose, selectedEvent }: CalendarReminderDetailProps) => {
    const dispatch = useDispatch<AppDispatch>();
    const { id } = useParams();
    const [showDelete, setShowDelete] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const { currentUser } = useSelector((state: RootState) => state.app);
    const { selectedCustomer } = useSelector((state: RootState) => state.customer);

    const deleteReminderHandler = async () => {
        setIsLoading(true);
        let user_id = 0;
        if (id && currentUser?.role !== 'client') {
            user_id = selectedCustomer?.id || 0;
        } else {
            user_id = currentUser?.id as number;
        }
        try {
            await dispatch(deleteDealReminderThunk({
                deal_id: selectedEvent?.deal_id as number,
                reminder_id: selectedEvent?.id as number
            })).unwrap();
            if (user_id && user_id !== 0) {
                await dispatch(fetchCalendarReminderThunk(id ? parseInt(id as string, 10) : 0)).unwrap();
                await dispatch(fetchGoogleEventsThunk(user_id)).unwrap();
            }
            onClose();
        } catch (e) {
            // Catch Errors
        } finally {
            setIsLoading(false);
        }
    };

    return <CustomModal open={open} handleClose={isLoading ? () => null : onClose} isError={showDelete} title={selectedEvent.title}>
        {showDelete
            ? <Box>
                <Typography variant="body1" align="center" mb={2}>Are you sure you want to delete a reminder name &quot;<Typography component="span" variant="body1" color={red[300]}>{selectedEvent?.title}</Typography>&quot;?</Typography>
                {/* Action buttons */}
                <Box display="flex" gap={2} mt={2}>
                    <Button variant="outlined" color="error" onClick={() => setShowDelete(false)} fullWidth disabled={isLoading}>
                        Cancel
                    </Button>
                    <Button type="submit" variant="contained" color="error" onClick={deleteReminderHandler} fullWidth disabled={isLoading}>
                        {isLoading ? 'Deleting...' : 'Delete Reminder'}
                    </Button>
                </Box>
            </Box>
            : <Box display="flex" flexDirection="column" gap={2}>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="h5">{selectedEvent.title}</Typography>
                </Box>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="body2">{formatDate((selectedEvent.start instanceof Date ? selectedEvent.start.toISOString() : selectedEvent.start) || '2025-01-24T05:00:00+05:00', {
                        month: 'long',
                        day: 'numeric',
                        year: 'numeric'
                    })}</Typography>
                    <Typography variant="body2">{formatTime((selectedEvent.start instanceof Date ? selectedEvent.start.toISOString() : selectedEvent.start) || '2025-01-24T05:00:00+05:00', {
                        hour: '2-digit',
                        minute: '2-digit',
                        hour12: true
                    })}</Typography>
                </Box>
                <Typography variant="body1" color="textSecondary">{selectedEvent.desc || 'Description is Empty'}</Typography>
                <Button variant="outlined" fullWidth color="error" onClick={() => setShowDelete(true)}>Delete Reminder</Button>
            </Box>}
    </CustomModal>;
};

export default CalendarReminderDetail;